/** Changing your own password. The only thing anyone can do to their own account. */
import React, { useState } from "react";

import { ApiError, api } from "../api.js";

export default function Account({ me }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [state, setState] = useState(null);

  async function submit(event) {
    event.preventDefault();
    if (next !== again) return setState({ level: "error", text: "The two new passwords are different." });
    try {
      await api.post("auth/password", { current, next });
      setState({ level: "ok", text: "Password changed. Your other devices have been signed out." });
      setCurrent("");
      setNext("");
      setAgain("");
    } catch (problem) {
      setState({ level: "error", text: problem instanceof ApiError ? problem.message : "Could not change it." });
    }
  }

  return (
    <>
      <div className="head">
        <div>
          <h1>My account</h1>
          <p className="sub">
            {me.displayName} — {me.role}
          </p>
        </div>
      </div>

      <form className="card" onSubmit={submit} style={{ maxWidth: "420px" }}>
        <header>
          <h2>Change my password</h2>
        </header>
        <div className="body">
          <div className="field">
            <label htmlFor="c">Current password</label>
            <input id="c" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
          </div>
          <div className="field">
            <label htmlFor="n">New password</label>
            <input id="n" type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required />
            <p className="help">At least 12 characters. A sentence only you would type is a good one.</p>
          </div>
          <div className="field">
            <label htmlFor="a">New password again</label>
            <input id="a" type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} required />
          </div>
          {state && <div className={`msg ${state.level}`}>{state.text}</div>}
          <button className="primary" style={{ marginTop: "0.5rem" }}>Change it</button>
        </div>
      </form>
    </>
  );
}
